import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Preloader from "../components/Preloader";
import ScrollToTop from "../components/ScrollToTop";
import MagnetCursor from "../components/MagnetCursor";

const PUB_API = "https://backenddev.aaerlaw.com/api/user/paraclearth_publications";
const SERVER = "https://backenddev.aaerlaw.com";

function BlogDetails() {
  const location = useLocation();
  const id = new URLSearchParams(location.search).get("id");

  const [pub, setPub] = useState(null);
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.style.display = "none";
  }, []);

  useEffect(() => {
    if (!id) { setNotFound(true); setLoading(false); return; }

    Promise.all([
      fetch(`${PUB_API}/${id}`).then((r) => {
        if (!r.ok) throw new Error("not found");
        return r.json();
      }),
      fetch(`${PUB_API}?page=1&limit=5`).then((r) => r.json()),
    ])
      .then(([publication, list]) => {
        setPub(publication);
        if (Array.isArray(list?.data)) setRecent(list.data);
      })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div>
        <Preloader />
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
          <div className="spinner-border text-secondary" role="status">
            <span className="visually-hidden">Loading&hellip;</span>
          </div>
        </div>
      </div>
    );
  }

  if (notFound || !pub) {
    return (
      <div>
        <Preloader />
        <div className="text-center py-5">
          <p>Publication not found.</p>
          <Link to="/blogone" className="btn btn-primary">View All Publications</Link>
        </div>
        <ScrollToTop />
        <MagnetCursor />
      </div>
    );
  }

  const dateStr = new Date(pub.created_at).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const imgSrc = pub.image ? `${SERVER}/${pub.image}` : "assets/img/bg-img/91.jpg";

  return (
    <div>
      {/* Preloader */}
      <Preloader />

      {/* Breadcrumb Section */}
      <div
        className="breadcrumb-section breadcrumb-compact bg-img jarallax"
        data-jarallax=""
        data-speed="0.6"
        style={{ backgroundImage: "url('assets/img/bg-img/73.jpg')" }}
      >
        <div className="divider"></div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="breadcrumb-content">
                <h2 className="wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="700ms">
                  {pub.title}
                </h2>
                <ul
                  className="list-unstyled wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="1000ms"
                >
                  <li><Link className="magnet-link" to="/">Home</Link></li>
                  <li><Link className="magnet-link" to="/blogone">Media &amp; Insights</Link></li>
                  <li>{pub.title}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      {/* Blog Wrapper */}
      <div className="blog-page-section bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-4 g-xl-5">
            {/* Main Content */}
            <div className="col-12 col-md-7 col-lg-8">
              <div className="single-blog">
                <img src={imgSrc} alt={pub.title} />

                <div className="blog-meta gap-4 d-flex flex-wrap align-items-center py-4 border-bottom mb-4">
                  {pub.law_area && <span>{pub.law_area}</span>}
                  <span>{dateStr}</span>
                </div>
              </div>

              <div className="blog-details-content">
                <div dangerouslySetInnerHTML={{ __html: pub.publication }} />
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-12 col-md-5 col-lg-4">
              <div className="d-flex flex-column gap-5">
                {/* Recent Posts */}
                {recent.length > 0 && (
                  <div className="blog-widget">
                    <div className="h4 mb-4">Recent Posts</div>
                    <div className="d-flex flex-column gap-4">
                      {recent.map((r) => (
                        <div key={r.id} className="widget-blog-post">
                          <div className="blog-thumbnail">
                            <img
                              src={r.image ? `${SERVER}/${r.image}` : "assets/img/bg-img/41.jpg"}
                              alt={r.title}
                            />
                          </div>
                          <div className="blog-content">
                            <Link to={`/blogdetails?id=${r.id}`}>{r.title}</Link>
                            <p className="mb-0">
                              {new Date(r.created_at).toLocaleDateString("en-GB", {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                              })}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Back to all publications */}
                <div className="blog-widget">
                  <Link to="/blogone" className="btn btn-primary w-100">
                    <span>All Publications <i className="ti ti-arrow-up-right"></i></span>
                    <span>All Publications <i className="ti ti-arrow-up-right"></i></span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </div>

      {/* Scroll To Top */}
      <ScrollToTop />

      {/* Magnet Cursor */}
      <MagnetCursor />
    </div>
  );
}

export default BlogDetails;
